export default "/images/kore-platform.svg?9328234006a80983876f88c9f0d7e028";